var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',_vm._b({attrs:{"label":_vm.optionsLabel,"append-to-body":"","options":_vm.options,"value":_vm.selectedValue,"filterable":false,"searchable":false,"clearable":false},on:{"input":_vm.setSelected}},'v-select',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }